<section class="ki-audit" data-testid="ki-audit-log">
  <div class="ki-audit__karte">
    <div class="ki-audit__kopf">
      <to-section-title
        class="ki-audit__titel"
        [title]="'ki.audit.titel' | translate"
        [subtitle]="(inhalteGespeichert() ? 'ki.audit.untertitelInhalte' : 'ki.audit.untertitelMetadaten') | translate"
      />
      <button
        mat-stroked-button
        type="button"
        class="ki-audit__export"
        data-testid="ki-audit-export"
        [disabled]="exportLaeuft()"
        (click)="exportieren()"
      >
        <span aria-hidden="true">↓</span>
        {{ 'ki.audit.export' | translate }}
      </button>
    </div>

    <div class="ki-audit__tabelle" role="table" tabindex="0" [attr.aria-label]="'ki.audit.tabelle' | translate">
      <div class="ki-audit__zeile ki-audit__zeile--kopf" role="row">
        <div class="ki-audit__spalte ki-audit__spalte--zeitpunkt" role="columnheader">
          {{ 'ki.audit.spalte.zeitpunkt' | translate }}
        </div>
        <div class="ki-audit__spalte ki-audit__spalte--benutzer" role="columnheader">
          {{ 'ki.audit.spalte.benutzer' | translate }}
        </div>
        <div class="ki-audit__spalte ki-audit__spalte--projekt" role="columnheader">
          {{ 'ki.audit.spalte.projekt' | translate }}
        </div>
        <div class="ki-audit__spalte ki-audit__spalte--funktion" role="columnheader">
          {{ 'ki.audit.spalte.funktion' | translate }}
        </div>
        <div class="ki-audit__spalte ki-audit__spalte--modell" role="columnheader">
          {{ 'ki.audit.spalte.modell' | translate }}
        </div>
        <div class="ki-audit__spalte ki-audit__spalte--tokens" role="columnheader">
          {{ 'ki.audit.spalte.tokens' | translate }}
        </div>
        <div class="ki-audit__spalte ki-audit__spalte--dauer" role="columnheader">
          {{ 'ki.audit.spalte.dauer' | translate }}
        </div>
        <div class="ki-audit__spalte ki-audit__spalte--ergebnis" role="columnheader">
          {{ 'ki.audit.spalte.ergebnis' | translate }}
        </div>
      </div>

      @if (laedt()) {
        <div class="ki-audit__hinweis" role="status" aria-live="polite" data-testid="ki-audit-laden">
          <mat-progress-spinner mode="indeterminate" diameter="32" [attr.aria-label]="'ki.audit.laden' | translate" />
        </div>
      } @else if (ladeFehler()) {
        <div class="ki-audit__hinweis ki-audit__fehler" role="alert" data-testid="ki-audit-fehler">
          <span class="ki-audit__fehler-text">{{ 'ki.audit.ladeFehler' | translate }}</span>
          <button mat-stroked-button type="button" data-testid="ki-audit-erneut" (click)="laden()">
            {{ 'ki.fehler.erneut' | translate }}
          </button>
        </div>
      } @else {
        @for (eintrag of eintraege(); track $index) {
          <div class="ki-audit__zeile ki-audit__zeile--eintrag" role="row" data-testid="ki-audit-zeile">
            <div class="ki-audit__spalte ki-audit__spalte--zeitpunkt" role="cell">
              {{ eintrag.zeitpunkt | date: 'dd.MM.yyyy HH:mm' }}
            </div>
            <div class="ki-audit__spalte ki-audit__spalte--benutzer" role="cell">{{ eintrag.benutzer }}</div>
            <div class="ki-audit__spalte ki-audit__spalte--projekt" role="cell">{{ eintrag.projekt ?? keinWert }}</div>
            <div class="ki-audit__spalte ki-audit__spalte--funktion" role="cell">{{ eintrag.funktion }}</div>
            <div class="ki-audit__spalte ki-audit__spalte--modell" role="cell">
              {{ eintrag.anbieter }} · {{ eintrag.modell }}
            </div>
            <div class="ki-audit__spalte ki-audit__spalte--tokens" role="cell">{{ tokens(eintrag.tokens) }}</div>
            <div class="ki-audit__spalte ki-audit__spalte--dauer" role="cell">{{ dauer(eintrag.dauerMs) }}</div>
            <div class="ki-audit__spalte ki-audit__spalte--ergebnis" role="cell">
              <span
                class="ki-audit__ergebnis"
                [class.ki-audit__ergebnis--ok]="eintrag.ergebnis === 'OK'"
                [class.ki-audit__ergebnis--fehler]="eintrag.ergebnis === 'FEHLER'"
                data-testid="ki-audit-ergebnis"
              >
                {{ 'ki.audit.ergebnis.' + eintrag.ergebnis | translate }}
              </span>
            </div>
          </div>
        } @empty {
          <div class="ki-audit__hinweis" data-testid="ki-audit-leer">{{ 'ki.audit.leer' | translate }}</div>
        }
      }
    </div>
  </div>

  @if (!laedt() && !ladeFehler() && gesamt() > 0) {
    <app-overview-pagination
      class="ki-audit__paginierung"
      [pageIndex]="seitenIndex()"
      [pageSize]="seitengroesse"
      [pageSizeOptions]="seitengroessen"
      [totalCount]="gesamt()"
      (pageIndexChange)="seiteWechseln($event)"
    />
  }
</section>
